<template>
  <v-container>
    <template v-slot:after-heading>
      <div class="display-1 mt-2 font-weight-light">
        {{ $t("product_configuration") }}
        <span class="body-1">- {{ $t("product_configuration_dex") }}</span>
      </div>
    </template>
    <form>
      <v-row>
        <v-col cols="12">
          <span v-html="condizioni" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6" md="8" class="text-center">
          <v-autocomplete
            v-model="discipline"
            :items="listDiscipline"
            outlined
            dense
            chips
            small-chips
            item-text="text"
            item-value="value"
            :label="$t('pick_your_discipline')"
            multiple
          ></v-autocomplete>
        </v-col>
        <v-col cols="6" md="4" class="text-center">
          <v-autocomplete
            v-model="qualifica"
            :items="listQualifiche"
            outlined
            dense
            item-text="description"
            item-value="qualifica"
            :label="$t('qualify')"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" class="text-center">
          <v-layout justify-center>
            <v-checkbox
              v-if="condizioni && condizioni !== ''"
              v-model="accepted"
              :label="$t('accept_condition')"
              color="success"
              :value="true"
              hide-details
            ></v-checkbox>
          </v-layout>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn
            v-if="!condizioni || condizioni === '' || accepted"
            @click="confirmCondition"
            color="success"
            >{{ $t("continue") }}</v-btn
          >
        </v-col>
      </v-row>
    </form>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "accept-condition",

  props: {
    idTessera: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      accepted: false,
      discipline: [],
      listDiscipline: null,
      qualifica: null,
      listQualifiche: [],
      condizioni: null,
    };
  },
  methods: {
    loadData() {
      let _ = this;
      if (_.idTessera) {
        let url = "/auth/tesseramenti/getTessera/" + _.idTessera;
        _.chiamataAxios("GET", url).then((response) => {
          _.condizioni = response.data.condizioni;
          _.listDiscipline = response.data.discipline;
          _.listQualifiche = response.data.qualifiche;
        });
      }
    },
    confirmCondition() {
      // Scegliere almeno una disciplina
      let _ = this;
      if (this.discipline.length === 0) {
        Swal.fire({
          type: "danger",
          html: "<strong>" + _.$t("pick_your_disciplines") + "</strong>",
          confirmButtonClass: "md-button md-success",
        });
      } else if (this.qualifica === null || this.qualifica === "") {
        Swal.fire({
          type: "danger",
          html: "<strong>" + _.$t("pick_your_qualify") + "</strong>",
          confirmButtonClass: "md-button md-success",
        });
      } else {
        this.$emit("confirmed", {
          confirmed: true,
          discipline: this.discipline,
          qualifica: this.qualifica,
        });
      }
    },
  },

  mounted() {
    this.loadData();
  },
  watch: {
    idTessera: function (newVal, oldVal) {
      // watch it
      if (newVal) this.loadData();
    },
  },
};
</script>